import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ContractUtils from "../utils/contractUtils";
import ContractUtilsV2 from "../utils/contractUtilsV2";
import { StoreContext } from "../store";
import { WalletContext } from "../context/wallet";

const Header = () => {
  const global = useContext(StoreContext);
  const [walletAddress, setWalletAddress] = useContext(WalletContext);

  useEffect(() => {
    const address = localStorage.getItem("walletLocalStorageKey");
    if (address) setWalletAddress(address);
  }, [walletAddress, setWalletAddress]);

  const onClickConnect = async () => {
    let res = await ContractUtils.connectWallet();
    if (res.address) {
      global.setShowToast(true);
      setWalletAddress(res.address);
      window.localStorage.setItem("walletLocalStorageKey", res.address);
    } else {
      global.setShowToast(true);
      setWalletAddress("");
    }
  };

  const onClickConnectWC = async () => {
    let res = await ContractUtilsV2.connectWallet();
    if (res.address) {
      global.setShowToast(true);
      setWalletAddress(res.address);
      window.localStorage.setItem("walletLocalStorageKey", res.address);
    } else {
      global.setShowToast(true);
      setWalletAddress("");
    }
  };

  const onClickDisconnect = async () => {
    await ContractUtils.disconnectWallet();
    await ContractUtilsV2.disconnectWallet();
    await window.localStorage.removeItem("walletLocalStorageKey");
    global.setShowToast(false);
    setWalletAddress("");
    window.location.reload();
  };

  const checkTarget = () => {
    const link = window.document?.location?.pathname;
    return link;
  };

  return (
    <>
      <header className="header">
        <div className="container-cthu">
          <div className="row">
            <div className="col-12">
              <div className="header__content">
                <a
                  href="https://renq.io"
                  target="_blank"
                  className="header__logo"
                >
                  <img src="/stake/staking-logo-blue.svg" alt="" />
                </a>
                <div className="navbar-left"></div>
                <ul
                  className="header__nav"
                  id="header__nav"
                  style={{
                    marginLeft: "auto",
                    justifyContent: "center",
                  }}
                >
                  <li>
                    {global.lan === false ? (
                      <Link to="https://www.renq.io">Home</Link>
                    ) : (
                      <Link to="/" style={{ marginLeft: "-30px" }}>
                        Главная
                      </Link>
                    )}
                  </li>
                  <li>
                    {global.lan === false ? (
                      <Link to="/stake">Stake</Link>
                    ) : (
                      <Link to="/stake">Stake</Link>
                    )}
                  </li>
                  <li>
                    {global.lan === false ? (
                      <Link to="/farm">Farm</Link>
                    ) : (
                      <Link to="/farm">Фарминг</Link>
                    )}
                  </li>
                  <li>
                    {global.lan === false ? (
                      <a href="https://app.testnet.live">Swap</a>
                    ) : (
                      <Link to="/farm">Фарминг</Link>
                    )}
                  </li>
                  <li>
                    {global.lan === false ? (
                      <a href="https://app.testnet.live/#/add/v2/ETH">Pool</a>
                    ) : (
                      <Link to="/farm">Фарминг</Link>
                    )}
                  </li>
                  {/* <li>
                    {global.lan === false ? (
                      <Link to="/faqs">FAQs</Link>
                    ) : (
                      <Link to="/faqs">FAQs</Link>
                    )}
                  </li> */}
                </ul>
                {/* {global.lan === false ? (
                  <button
                    className="nav-button"
                    onClick={() => global.setLan(true)}
                  >
                    <img src="/language-white.png" alt="" />
                  </button>
                ) : (
                  <button
                    className="nav-button"
                    onClick={() => global.setLan(false)}
                  >
                    <img src="/language-white.png" alt="" />
                  </button>
                )} */}
                <ul
                  style={{
                    display: "flex",
                    justifySelf: "center",
                    paddingRight: "30px",
                    marginTop: "16px",
                  }}
                >
                  <a
                    href="https://t.me/renqfinance"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <li className="nav-send me-2">
                      <i className="fa fa-send"></i>
                    </li>
                  </a>
                  {/* <a
                    href="https://cthulhu-farm.gitbook.io/cthulhu-farm/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <li className="nav-user me-2">
                      <img src="../../svgs/Path3.svg" alt="" />
                    </li>
                  </a> */}
                  <a
                    href="https://twitter.com/RenQ_Finance"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <li className="nav-twitter me-2">
                      <i className="fa fa-twitter"></i>
                    </li>
                  </a>
                  {/* <a
                    href="https://github.com/CthulhuFarm"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <li className="nav-twitter me-2">
                      <i className="fa fa-github"></i>
                    </li>
                  </a> */}
                </ul>
                <button className="header__cta">
                  {walletAddress === "" ? (
                    <>
                      {global.lan === false ? (
                        <>
                          <span onClick={() => onClickConnect()}>
                            <img
                              src="../stake/svgs/MetaMask_Fox.svg"
                              width={20}
                              height={20}
                              alt=""
                            />
                            CONNECT
                          </span>
                          <span onClick={() => onClickConnectWC()}>
                            <img
                              src="../stake/svgs/Wc.svg"
                              width={20}
                              height={20}
                              alt=""
                            />
                            WalletConnect
                          </span>
                        </>
                      ) : (
                        <span
                          onClick={() => onClickConnect()}
                          style={{ fontSize: "12px" }}
                        >
                          ПОДКЛЮЧИТЬ
                        </span>
                      )}
                    </>
                  ) : (
                    <>
                      <span onClick={() => onClickDisconnect()}>
                        {walletAddress.substr(0, 4)}...{walletAddress.slice(38)}
                      </span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
